import React, { FC } from "react";
import { Card } from "antd";

import useHttpGet from "../../../../hooks/useHttpGet";
import { APIRoutes } from "../../../../http";
import InstrumentsMarqueeItem from "./InstrumentsMarqueeItem";
import { IResultResponse } from "../../../../models/response/result.model";
import { ILayoutRibbon } from "../../../../models/layout-ribbon.model";

const InstrumentsMarquee: FC = () => {
  const { fetchedData, loading } = useHttpGet<IResultResponse<ILayoutRibbon[]>>(
    `${APIRoutes.LAYOUT_RIBBON}`,
    {
      defaultValue: {
        result: [] as ILayoutRibbon[],
      },
    }
  );

  const ci = fetchedData.result.filter(
    (el: ILayoutRibbon) => !!el.indexId
  );

  const instruments = fetchedData.result.filter(
    (el: ILayoutRibbon) => !!el.idInstrument
  );

  return (
    <Card loading={loading} bordered={false} className="custom-card-1">
      <div className="b-marquee">
        <div className="b-marquee-fixed">
          {ci?.map((el: ILayoutRibbon) => (
            <InstrumentsMarqueeItem isIndex item={el} key={el.indexId} />
            ))}
        </div>
        <div className="b-marquee__text d-flex">
          {instruments?.map((el: ILayoutRibbon) => (
            <InstrumentsMarqueeItem item={el} key={el.idInstrument} />
          ))}
        </div>
      </div>
    </Card>
  );
};

export default InstrumentsMarquee;